import { Component, OnInit, ViewEncapsulation, OnDestroy } from '@angular/core';
import { Validators, UntypedFormGroup, UntypedFormBuilder } from '@angular/forms';
import { Title } from '@angular/platform-browser';
import { ToastController, LoadingController  } from '@ionic/angular';
import { AppRouterService } from '../../core/services/app-router.service';
import { BackendService } from '../../core/services/backend-prod.service';
import { Storage } from '@ionic/storage';
import { HelperService } from '../../core/services/helper.service';
import { VendorBackendService } from 'src/app/core/services/vendor-services/vendor-backend.service';

@Component({
  selector: 'app-sign-up',
  templateUrl: './sign-up.component.html',
  styleUrls: ['./sign-up.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class SignUpComponent implements OnInit, OnDestroy {
  private countriesApi: any;
  private registerApi: any;
  showempcom: boolean = true;

  constructor(
    private title: Title,
    private fb: UntypedFormBuilder,
    public toastController: ToastController,
    private vendorBackendService: VendorBackendService,
    private appRouter: AppRouterService,
    public loadingController: LoadingController,
    public storage: Storage,
    public helperService: HelperService
  ) { }

  jobTitle;
  employee;
  countries;
  signupform: UntypedFormGroup;
  submitted: boolean = false;
  submitdone: boolean = false;
  private userIp;

  ngOnInit() {
    this.title.setTitle('eZintegrations | Vendor sign-up ');
    this.jobTitle = this.helperService.jobTitle;
    this.employee = this.helperService.employee;
    this.getcountries();
    
    this.signupform = this.fb.group({
      'firstName': ['', [Validators.required, Validators.pattern('^[a-zA-Z0-9\s]+([a-zA-Z0-9 ]+)*$')]],
      'lastName': ['', [Validators.required, Validators.pattern('^[a-zA-Z0-9\s]+([a-zA-Z0-9 ]+)*$')]],
      'email': ['', [Validators.required, Validators.email,Validators.pattern('^[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,4}$')]],
      // 'phone': ['', [Validators.required,Validators.pattern('^[6-9][0-9]{9}$'),
      //                Validators.minLength(10), Validators.maxLength(10)]],
      'phone': ['', [Validators.required,Validators.pattern('^[0-9+(][0-9-+(). ]*$'),
                       Validators.minLength(10), Validators.maxLength(18)]],
      'jobTitle': ['', Validators.required],
      'employee': ['', Validators.required],
      'company': ['', Validators.required],
      'country': ['', Validators.required],
      'agreeSubscription': [false, Validators.requiredTrue],
    });

    this.signupform.get('jobTitle').valueChanges.subscribe(val => {
      if (val.id == "6" || val.id == "7") {
        this.signupform.controls['employee'].clearValidators();
        this.signupform.controls['company'].clearValidators();
        this.showempcom = false;
      } else {
        this.signupform.controls['employee'].setValidators([Validators.required]);
        this.signupform.controls['company'].setValidators([Validators.required]);
        this.showempcom = true;
      }
      this.signupform.controls['employee'].updateValueAndValidity();
      this.signupform.controls['company'].updateValueAndValidity();
    })
    this.getUserIp();
  }

 getcountries(){
    // this.helperService.loader();
    this.countriesApi =  this.vendorBackendService.Get('getAllCountries').subscribe(
      (data) => {
        this.countries = data;
        // this.helperService.closeLoader();
      },
      (error)=>{
        //console.log(error);
        // this.helperService.closeLoader();
        this.helperService.handleError(error);
      }
    );
  } 

  get f() { return this.signupform.controls; }

  getUserIp(){
    this.vendorBackendService.getUserIp().subscribe(
      (data) => {
        const e: any = data as any;
        //console.log(e);
        this.userIp = e.ip;
    })
  }

  async onSubmit() {
    this.submitted = true;
    this.submitdone = true;
    if (this.signupform.invalid) {
      return;
    }
    let payload = {
      // "first_name": "Jitendra",
      // "last_name": "Kelhe",
      // "email": "jskelhe6@bizdata360.com",
      // "phone_no": "9890098900",
      // "job_title": "CXO/General Manager",
      // "employee": "1 - 15 Employees",
      // "company": "company",
      // "country": "India",
      // "create_ip_address": "49.36.57.126"
  
      first_name: this.signupform.value.firstName.trim(),
      last_name: this.signupform.value.lastName.trim(),
      email:  this.signupform.value.email.trim(),
      phone_no: this.signupform.value.phone.trim(),
      job_title: this.signupform.value.jobTitle.name,
      employee: this.signupform.value.employee,
      company: this.signupform.value.company,
      country: this.signupform.value.country,
      // freeTrialMode: true,
      create_ip_address: this.userIp
    }
    
    // console.log(payload)
    await this.helperService.loader();
    this.registerApi = this.vendorBackendService.Post('register', payload)
      .subscribe(
        data => {
          this.submitted = false;
          // this.signupform.reset();
          this.helperService.closeLoader().then(()=>{
            if (data && data.token) {
              // this.sessionService.storeUserDetails(data, false, true);
              this.storage.set('token', data.token);
              this.storage.set('id', data.id);
              this.storage.set('email', data.work_email);
              this.storage.set('first_name', data.first_name);
              this.storage.set('last_name', data.last_name);
              // this.storage.set('free_trial_mode', data.free_trial_mode == 1? true:false);
              this.storage.set('job_title', data.job_title);
              this.helperService.presentAlert('Verify Account!', 'Check your email to verify your account. You can login back only once you confirm your email');
              // this.appRouter.gotoPath('baseapp/integration/create');
            } 
            else {
              this.helperService.presentToast('Something went wrong please try again later.', 2000);
            }
          });
        },
        error => {
          this.helperService.handleError(error);
              this.helperService.closeLoader();
        }
    );
  }

  ngOnDestroy(){
    this.countriesApi.unsubscribe();
    if(this.submitdone){
      this.registerApi.unsubscribe();
    }
    // this.helperService.closeLoader();
  }

}
